/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import Button from '@material-ui/core/Button';
import { Box, Link, TextField, Typography } from '@material-ui/core';
import { login } from '../../graphql/mutation';
import { yup } from '../../constants';
import { loginClasses } from '../../themes';
import { client } from '../../graphql';
import CountDown from '../../Shared/CountDown';

const timeToWait = 900000;
const possibleWrong = 15;

const Login = ({
  dispatch,
  wrongTimes,
  startBlock,
  isRTL,
  height,
}: any): any => {
  const classes = loginClasses();
  const [error, seterror] = useState(null);

  const { register, handleSubmit, errors }: any = useForm(yup.loginResolver);

  const [dologin] = useMutation(login);

  const timeFromBlock = Date.now() - startBlock;
  const validtime = startBlock ? timeFromBlock > timeToWait : true;
  const remaningTime = Math.floor((timeToWait - timeFromBlock) / 1000);

  const initStoreState = () => {
    dispatch({ type: 'setLastSuccess', payload: Date.now() });
    dispatch({ type: 'setWrongTimes', payload: 0 });
    dispatch({ type: 'setStartBlock', payload: null });
  };

  useEffect(() => {
    if (validtime) {
      initStoreState();
    }
  }, [validtime]);

  const onSubmit = async (dt: any) => {
    const { username, password } = dt;
    const userData = await dologin({ variables: { username, password } });
    if (userData?.data?.login?.ok === true) {
      const u = userData?.data?.login?.data;
      const isAllowed = u?.isSuperAdmin || u?.isAccountant;
      if (!isAllowed) {
        seterror('Nor Allowed');
        return;
      }
      initStoreState();
      const { data, accessToken, refreshToken, tempId, template } =
        userData.data.login;
      const user = {
        ...data,
        roles: JSON.parse(data.roles),
      };
      await client.resetStore();
      const token = JSON.stringify({ accessToken, refreshToken });
      const temp = JSON.parse(template);
      dispatch({
        type: 'login',
        payload: { user, token, template: temp, tempId },
      });
      dispatch({
        type: 'setThemeId',
        payload:
          user?.themeId || user?.themeId === 0
            ? user?.themeId
            : template?.id - 1,
      });
      seterror(null);
      window.location.reload();
    } else if (userData?.data?.login?.ok === false) {
      seterror(userData.data.login.error);
      dispatch({ type: 'setWrongTimes' });
      if (wrongTimes > possibleWrong) {
        dispatch({ type: 'setStartBlock', payload: Date.now() });
      }
    }
  };

  const keyPress = (e: any) => {
    if (e.keyCode === 13) {
      handleSubmit(onSubmit)();
    }
  };

  if (!validtime) {
    return <CountDown time={remaningTime}></CountDown>;
  }

  return (
    <Box
      display="flex"
      style={{
        flex: 1,
        height: height - 100,
        justifyContent: 'center',
      }}
    >
      <div style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
        <div className={classes.paper}>
          <Box
            style={{
              paddingTop: 10,
              borderRadius: 10,
              paddingBottom: 20,
            }}
          >
            <form className={classes.form} noValidate>
              <Box m={3}>
                <TextField
                  label={isRTL ? 'بريد الكتروني' : 'Email'}
                  name="username"
                  inputRef={register}
                  error={errors.username ? true : false}
                  onKeyDown={keyPress}
                  size="medium"
                  inputProps={{
                    style: {
                      height: 32,
                      fontSize: 16,
                      margin: 0,
                      paddingLeft: 10,
                      paddingRight: 10,
                    },
                  }}
                  style={{ marginBottom: 20 }}
                  required
                  fullWidth
                />
                <TextField
                  name="password"
                  label={isRTL ? 'كلمة المرور' : 'Password'}
                  type="password"
                  inputRef={register}
                  error={errors.password ? true : false}
                  onKeyDown={keyPress}
                  helperText={error ? error : undefined}
                  inputProps={{
                    style: {
                      height: 32,
                      fontSize: 16,
                      margin: 0,
                      paddingLeft: 10,
                      paddingRight: 10,
                    },
                  }}
                  style={{ marginBottom: 20 }}
                  required
                  fullWidth
                />

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{ height: 42, fontSize: 16, marginTop: 30 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  {isRTL ? 'تسجبل الدخول' : 'Login'}
                </Button>
              </Box>
            </form>
          </Box>
        </div>
        <Box
          display="flex"
          style={{
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 80,
          }}
        >
          <Typography variant="body1" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://tadween.qa/">
              Tadween
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Box>
      </div>
    </Box>
  );
};
export default Login;
